// src/pages/AdminChat.js
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { db } from "../Firebase/Config";
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import "./AdminChat.css"; // optional, see below

function AdminChat() {
  const { uid } = useParams();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);

  // Listen for messages
  useEffect(() => {
    const q = query(
      collection(db, "messages", uid, "messages"),
      orderBy("timestamp")
    );
    const unsub = onSnapshot(q, (querySnapshot) => {
      const msgs = [];
      querySnapshot.forEach((doc) => {
        msgs.push({ id: doc.id, ...doc.data() });
      });
      setMessages(msgs);
    });
    return () => unsub();
  }, [uid]);

  // Scroll to bottom when messages update
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Send a message as admin
  const sendMessage = async (e) => {
    e.preventDefault();
    if (input.trim() === "") return;
    await addDoc(collection(db, "messages", uid, "messages"), {
      sender: "admin",
      text: input,
      timestamp: serverTimestamp(),
    });
    setInput("");
  };

  return (
    <div className="admin-chat-wrapper">
      <h2>Message User: {uid}</h2>
      <div className="chat-history">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`chat-message ${msg.sender === "admin" ? "admin" : "user"}`}
          >
            <span className="chat-sender">{msg.sender}:</span>
            <span className="chat-text">{msg.text}</span>
            <span className="chat-timestamp">
              {msg.timestamp?.toDate
                ? msg.timestamp.toDate().toLocaleString()
                : ""}
            </span>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <form className="chat-input-form" onSubmit={sendMessage}>
        <input
          type="text"
          placeholder="Type your message…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="chat-input"
        />
        <button type="submit" className="chat-send-btn">
          Send
        </button>
      </form>
    </div>
  );
}

export default AdminChat;
